import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css';
import { App } from './App';
import type { InvitesData } from './types';
import './styles.css';

const EMPTY: InvitesData = { isGuest: true, isAdmin: false, sentTotal: 0, hero: [], rows: [] };

function parseInitial(raw: string | undefined): InvitesData {
    if (!raw) return EMPTY;
    try {
        return JSON.parse(raw) as InvitesData;
    } catch {
        return EMPTY;
    }
}

const el = document.getElementById('invites-root');
if (el) {
    const initial = parseInitial(el.dataset.initial);
    createRoot(el).render(
        <StrictMode>
            <App
                inviteId={el.dataset.inviteId ?? ''}
                inviteUrl={el.dataset.inviteUrl ?? ''}
                csrf={el.dataset.csrf}
                initial={initial}
            />
        </StrictMode>,
    );
}
